import React from 'react';

interface IV3DropdownInfoProps {
    heading?: React.ReactNode;
    info?: React.ReactNode;
    wrapperClass?: string;
}

/** Heading + text card for CellDropdown / V3 tooltips. Port of WALHQ's V3DropdownCmp/V3DropdownInfo. */
const V3DropdownInfo = ({ heading, info, wrapperClass = '' }: IV3DropdownInfoProps) => (
    <div className={`min-w-[240px] max-w-[280px] space-y-1.5 text-left whitespace-normal break-words ${wrapperClass}`}>
        <p className="font-semibold text-grayLight900 text-xs">{heading}</p>
        <p className="text-textSecondary text-xs leading-[1.5] font-normal">{info || ''}</p>
    </div>
);

export default V3DropdownInfo;
